import styled from "styled-components";
import { Typography } from "components/parts/Typography/Typography";
import { newColors } from "constants/newColors";
import { ImageAdd } from "@styled-icons/remix-fill";

export const StyledFilePage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const StyledFilePasteModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  width: 100%;
  height: 100%;
`;

export const StyledFilePasteModalTypography = styled(Typography)`
  min-height: 1em;
`;

export const StyledPasteArea = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  justify-content: center;
  align-items: center;
  background: ${newColors.background};
  border-radius: 5px;
  width: 100%;
  height: 90%;
`;

export const StyledIconWithTypography = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledImageAdd = styled(ImageAdd)`
  display: flex;
  height: 30%;
  color: ${newColors.iconGray};
`;

export const StyledFileManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  padding: 1rem 1rem 0 1rem;
  box-sizing: border-box;
`;

export const StyledHeadline = styled.div`
  display: flex;
  margin-bottom: 1rem;
  column-gap: 0.5rem;
`;

export const StyledFileListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;

export const StyledNoDataTypography = styled(Typography)`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
  box-sizing: border-box;
  width: 100%;
  color: ${newColors.text};
`;

export const StyledMediaContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
